import { STATUS } from "@/constant/statusConstants";

const PlayerCareerInitialValues = (showData) => ({
  team_id: showData?.data?.team_id || "",
  player_id: showData?.data?.player_id || "",
  term_id: showData?.data?.term_id || "",
  status: showData?.data?.status || STATUS.ACTIVE,
});

export default PlayerCareerInitialValues;
